import { GameEvents } from "../utils/Types";
import { BasicButton } from "./BasicButton";

export class BreakButton extends BasicButton {
  constructor(scene: Phaser.Scene) {
    super(
      scene,
      "Break",
      {
        textureKey: "Button1",
      },
      {
        textureKey: "Button2",
      },
      undefined,
      undefined,
    );
    this.background.setTint(0xac4c3f);
  }

  handlePointerDown(): void {
    // Custom behavior for pointer down
    this.scene.game.events.emit(GameEvents.BREAK_WHEEL_ON);
  }

  handlePointerUp(): void {
    // Custom behavior for pointer up
    this.scene.game.events.emit(GameEvents.BREAK_WHEEL_OFF);
  }

  handlePointerOver(): void {
    // Custom behavior for pointer over
  }

  handlePointerOut(): void {
    // Custom behavior for pointer out
    this.scene.game.events.emit(GameEvents.BREAK_WHEEL_OFF);
  }
}
